export default "__VITE_ASSET__dea683f2__"